import { createContext } from 'react';

/* This is the Types for tsx file. For some reason when this file is .tsx things don't compile. 🤷‍. For a latter date.
type ColorScalesContextType = {
	getColor: (defaultColors: Array<string>) => (appSpecificColors: Array<string>) => (value: string) => string
}
export const ColorScalesContext = createContext<ColorScalesContextType>(null);*/

export const ColorScalesContext = createContext(null);
